import type {
  PlanOverviewResponse,
  PlanOverviewV3Response,
} from '@dreamai/types';

export function isV3PlanOverview(
  overview: PlanOverviewResponse | null | undefined,
): overview is PlanOverviewV3Response {
  return overview?.billingModel === 'v3';
}

const CURRENCY_SYMBOLS: Record<string, string> = {
  GBP: '£',
  USD: '$',
  EUR: '€',
};

/** "£30/month" from the offer / subscription price. */
export function formatPlanPrice(price: {
  amount: number;
  currency: string;
  periodUnit: string;
}): string {
  const code = price.currency.toUpperCase();
  const symbol = CURRENCY_SYMBOLS[code];
  const amount = Number.isInteger(price.amount)
    ? String(price.amount)
    : price.amount.toFixed(2);
  const money = symbol ? `${symbol}${amount}` : `${amount} ${code}`;
  const unit = price.periodUnit.toLowerCase().replace(/ly$/, '');
  return `${money}/${unit}`;
}
